import { render } from "./EinkaufslisteView.vue?vue&type=template&id=6e989553&scoped=true"
import script from "./EinkaufslisteView.vue?vue&type=script&lang=js"
export * from "./EinkaufslisteView.vue?vue&type=script&lang=js"

import "./EinkaufslisteView.vue?vue&type=style&index=0&id=6e989553&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e989553"]])

export default __exports__